/**
 * Back-in-stock notifier — submit handler dla form'a w PDP gdy produkt out of stock.
 *
 * Markup: `partials/woocommerce/content-single-product.php` →
 *   <div data-hn-bis data-product-id="...">
 *     <form data-hn-bis-form>
 *       <input name="email">
 *     </form>
 *     <p data-hn-bis-success hidden>...</p>
 *     <p data-hn-bis-error hidden></p>
 *   </div>
 *
 * Endpoint: POST /wp-json/hn/v1/back-in-stock {product_id, email}.
 * Rate-limit serwerowy: 5 zapisów / godz / IP + 1 / email / 24h (inc/back-in-stock.php).
 */

function resolveEndpoint() {
    const apiLink = document.querySelector('link[rel="https://api.w.org/"]');
    const base = apiLink ? apiLink.href : '/wp-json/';
    return base.replace(/\/$/, '') + '/hn/v1/back-in-stock';
}

function setMessage(container, type, text) {
    const success = container.querySelector('[data-hn-bis-success]');
    const error   = container.querySelector('[data-hn-bis-error]');
    if (success) {
        success.hidden = type !== 'success';
        if (type === 'success' && text) success.textContent = text;
    }
    if (error) {
        error.hidden = type !== 'error';
        if (type === 'error' && text) error.textContent = text;
    }
}

async function handleSubmit(event) {
    const form = event.target;
    if (!form.matches('[data-hn-bis-form]')) return;

    event.preventDefault();
    const container = form.closest('[data-hn-bis]');
    if (!container) return;

    const productId = parseInt(container.dataset.productId, 10);
    const emailInput = form.querySelector('input[name="email"]');
    const email = emailInput ? emailInput.value.trim() : '';
    const button = form.querySelector('button[type="submit"]');

    if (!email || !productId) {
        setMessage(container, 'error', 'Podaj poprawny adres email.');
        return;
    }

    if (button) button.disabled = true;
    setMessage(container, null, '');

    try {
        const response = await fetch(resolveEndpoint(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ product_id: productId, email }),
        });
        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
            // 429 = rate-limit, 400 = invalid email, 404 = product missing
            const msg = (data && data.message) || (response.status === 429
                ? 'Za dużo prób — spróbuj ponownie później.'
                : 'Nie udało się zapisać. Spróbuj ponownie.');
            setMessage(container, 'error', msg);
            return;
        }

        // Sukces — ukryj formularz, pokaż komunikat (success div ma już tekst z PHP).
        form.hidden = true;
        setMessage(container, 'success', '');
    } catch (err) {
        setMessage(container, 'error', 'Błąd połączenia. Spróbuj ponownie.');
    } finally {
        if (button) button.disabled = false;
    }
}

export function initBackInStock() {
    if (!document.querySelector('[data-hn-bis-form]')) {
        return;
    }
    document.addEventListener('submit', handleSubmit);
}
